import React from "react";
import { StyleSheet, View } from "react-native";
import { Checkbox, Text } from "react-native-paper";
import { FieldDisplayRendererProps } from "./types";
import { getBoardValueStyleByRules } from "../../../utils/boardValueStyle";

export const BooleanCheckboxDisplayRenderer = ({
  field,
  value,
  t,
}: FieldDisplayRendererProps) => {
  if (field.booleanDisplayMode === "inlineText") {
    const valueStyle = getBoardValueStyleByRules(
      value,
      field.boardValueColorRules,
    );

    return (
      <View style={styles.row}>
        <Text>{t(field.label)}:</Text>
        <Text style={[styles.inlineValue, valueStyle]}>
          {value ? t("Yes") : t("No")}
        </Text>
      </View>
    );
  }

  return (
    <View>
      <Text>{t(field.label)}</Text>
      <Checkbox.Item label="" status={value ? "checked" : "unchecked"} />
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  inlineValue: {
    fontWeight: "600",
  },
});
